import { render, staticRenderFns } from "./PlanPricing.vue?vue&type=template&id=30610d1e&scoped=true"
import script from "./PlanPricing.vue?vue&type=script&lang=js"
export * from "./PlanPricing.vue?vue&type=script&lang=js"
import style0 from "./PlanPricing.vue?vue&type=style&index=0&id=30610d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30610d1e",
  null
  
)

export default component.exports